import { useNavigate, useParams } from 'react-router-dom';
import { Lock, Sparkles } from 'lucide-react';
import {
  Button,
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription,
  DialogFooter,
} from '@vnetwork/ui/primitives';

/**
 * Upgrade prompt shown when a customer triggers a plan-gated ACTION (create /
 * enable) on a feature their subscription doesn't include. The feature pages
 * themselves stay fully browsable — only the mutating action is gated, and it
 * opens this popup instead of running. The CTA deep-links to the service's
 * subscription plan picker (Settings → Subscription).
 */
export function WaapUpgradeDialog({
  open,
  onOpenChange,
  feature,
}: {
  open: boolean;
  onOpenChange: (o: boolean) => void;
  feature: string;
}) {
  const navigate = useNavigate();
  const { serviceId } = useParams<{ serviceId: string }>();

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle
            style={{ display: 'inline-flex', alignItems: 'center', gap: 'var(--vn-space-2)' }}
          >
            <Lock size={18} />
            Upgrade required
          </DialogTitle>
          <DialogDescription>
            {feature} is available on the Pro plan and above. Upgrade this service's subscription
            to unlock it — along with the rest of the Pro protection suite.
          </DialogDescription>
        </DialogHeader>
        <DialogFooter>
          <Button variant="secondary" onClick={() => onOpenChange(false)}>
            Maybe later
          </Button>
          <Button
            startIcon={<Sparkles size={16} />}
            onClick={() => navigate(`/services/waap/${serviceId}/settings`)}
          >
            View plans
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
